import { MutableRefObject, useEffect, useRef, useState } from "react";
import { calculateInputLeft, useTooltip } from "../hooks/useTooltip";
import "../../styles/inputs/DropdownInput.css";
export { DropdownInput };
type Props = {
  className?: string;
  value: string;
  onChange: (val: string) => void;
  suggestions: string[];
  filterFn?: (value: string, suggestion: string) => boolean;
};

const DropdownInput = (props: Props) => {
  // triggerRef because react-laang doesn't update when our buttons rerendered
  const triggerRef = useRef<HTMLInputElement | null>(null);
  // container to attach suggestion tooltips too as tooltip cannot be attached to <input>
  const divRef = useRef<HTMLDivElement | null>(null);

  const [value, setValue] = useState(props.value);

  useEffect(() => {
    if (value !== props.value) {
      setValue(props.value);
    }
  }, [props.value]);

  const { isOpen, layerProps, renderLayer, setOpen, triggerProps } = useTooltip(
    undefined as unknown as MutableRefObject<HTMLInputElement | null>,
    undefined,
    undefined,
    undefined,
    "bottom-start",
    ["bottom-start"],
    true,
  );

  // update react-laang trigger ref as needed
  useEffect(() => {
    triggerProps?.ref(triggerRef.current);
  }, [triggerRef, triggerRef.current]);

  return (
    <div className={`DropdownInput ${props.className ?? ""}`} ref={divRef}>
      <input
        {...triggerProps}
        type={"text"}
        ref={triggerRef}
        value={value}
        // TODO: test that pressing enter on this input closes popup!
        onBlur={() => {
          // setOpen(false);
          props.onChange(value);
        }}
        onFocus={() => setOpen(true)}
        onKeyDown={({ key }) => {
          key === "Enter" && props.onChange(value);
        }}
        // handle NaN
        onChange={(e) => {
          setValue(e.target.value);
        }}
      />

      {isOpen &&
        renderLayer(
          <div
            {...layerProps}
            className={"suggestionWrapper"}
            // merge layerProps.style
            style={{
              ...layerProps.style,
              display: undefined,
              width: divRef.current!.clientWidth - 2,
              left: calculateInputLeft(divRef.current!),
              height: "auto",
            }}
          >
            {props.suggestions
              .filter((sugg) =>
                props.filterFn == undefined
                  ? true
                  : props.filterFn(value, sugg),
              )
              .map((x, i) => (
                <span
                  key={x + i}
                  className={"suggestion monospace"}
                  onClick={() => {
                    setOpen(false);
                    setValue(x);
                    props.onChange(x);
                  }}
                >
                  {" "}
                  {x}
                </span>
              ))}
          </div>,
        )}
    </div>
  );
};
